import { trpc } from '@web/lib/trpc';

import { ContactDetailsCard } from './contact-details-card';

type EditContactDialogProps = {
  contactId: string;
  onClose?: () => void;
};

export function EditContactDialog({
  contactId,
  onClose,
}: EditContactDialogProps) {
  const { data: contactDetailsData, refetch: refetchContactData } =
    trpc.contact.getContactBasicInfo.useQuery({
      contactId,
    });

  const { mutateAsync: updateContactMutation } =
    trpc.contact.updateContactWithDetails.useMutation();

  if (!contactDetailsData) return null;

  const defaultValues = {
    firstName: contactDetailsData.firstName,
    lastName: contactDetailsData.lastName,
    phoneNumber: contactDetailsData.phoneNumber,
    email: contactDetailsData.email ?? '',
  };

  return (
    <ContactDetailsCard
      contact={defaultValues}
      onClose={() => {
        void refetchContactData();

        onClose?.();
      }}
      onSubmit={async (data) => {
        await updateContactMutation({
          contactId,
          contactData: {
            ...data,

            address: 'address',
            city: 'city',
            state: 'state',
            sex: 'female',
            zipCode: 'zipCode',
            maritalStatus: 'married',
          },
        });
      }}
    />
  );
}
